var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-floatings"},[(_vm.user && !_vm.expireAt && _vm.shouldRender)?_c('FloatingInterest',{attrs:{"chat":_vm.chat,"interests":_vm.interests}}):_vm._e(),(_vm.user)?_c('PrivacyStatus'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }